import { BrowserRouter } from "react-router-dom";
import { useEffect } from "react";
import AppRoutes from "./routes/AppRoutes";
import { connectSocket } from "./socket/Socket";
import { getCurrentUserId } from "./utils/auth";
// import ProfileProvider from "./context/ProfileContext";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {

  // ===== SOCKET.IO FOR NOTIFICATION START ===== //
  useEffect(() => {
    const userId = getCurrentUserId();

    if (userId) {
      connectSocket(userId);
    }
  }, []);
  // ===== SOCKET.IO FOR NOTIFICATION END ===== //


  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </>

  );
}

export default App;
